/**
 * Agent capability catalog. Surfaces what the EXPAI agent can and cannot
 * do today, what is planned, and which features require Enterprise plans.
 * Consumed by {@link AgentCapabilitiesPanel}.
 */

export interface CapabilityExample {
  title: string;
  example: string;
}

export interface CapabilityGroup {
  module: string;
  items: CapabilityExample[];
}

export const liveCapabilities: CapabilityGroup[] = [
  {
    module: 'Producción',
    items: [
      { title: 'Consultar órdenes de trabajo', example: '¿Qué WOs están activas en la Línea A?' },
      { title: 'Ver progreso de producción', example: 'Muéstrame el progreso de WO-2024-0892.' },
      { title: 'Detectar cuellos de botella', example: '¿Dónde tenemos el cuello de botella ahora?' },
    ],
  },
  {
    module: 'Calidad',
    items: [
      { title: 'Listar no conformidades', example: 'Lista las NCs críticas abiertas.' },
      { title: 'Crear NC desde chat', example: 'Crea una NC mayor para la WO-892.' },
    ],
  },
  {
    module: 'Mantenimiento',
    items: [
      { title: 'Estado de máquinas', example: '¿Cuál es el estado de la máquina M-101?' },
      { title: 'Próximos PMs', example: '¿Qué mantenimientos preventivos toca esta semana?' },
    ],
  },
  {
    module: 'Trazabilidad',
    items: [
      { title: 'Buscar por serial / SSCC', example: 'Busca el SSCC 0010012345678901.' },
    ],
  },
];

export const limitations: string[] = [
  'No ejecuta acciones financieras ni de facturación.',
  'No modifica configuración crítica de dispositivos sin confirmación explícita de un supervisor.',
  'No realiza disposiciones de NC sin firma humana cuando la confianza del modelo es <70%.',
  'No accede a datos fuera de tu organización actual.',
  'No reemplaza al operador en decisiones de seguridad (LOTO, EHS).',
];

export const planned: string[] = [
  'Generación automática de informes FAI (Part 21 / AS9102).',
  'Análisis predictivo de OEE con horizonte 7 días.',
  'Asistencia en programación de turnos.',
  'Reconocimiento por voz en planta (Modo Planta).',
];

export const enterprise: string[] = [
  'Integración directa con SAP S/4HANA y Oracle EBS.',
  'Modelos de visión custom entrenados con tus datos.',
  'SLA 99.95 % con soporte 24/7 dedicado.',
  'Despliegue on-premise / air-gapped.',
  'Auditoría inmune (EASA / AESA) con cadena hash firmada.',
];
